var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_vm._l((_vm.messages),function(message){return _c('div',{key:message},[_vm._v(" "+_vm._s(message)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }